var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiLgFeedback = function SvgAiLgFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 61 30"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-lg-feedback_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.02,
    height: 17.819,
    x: 35.98,
    y: 1,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 15,
    y: 11.334,
    fill: "#CBFF88",
    rx: 5,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.555,
    height: 6,
    x: 31,
    y: 22,
    fill: "#CBFF88",
    rx: 3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M19.625 4.445h17.93v11.222h-17.93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M40.045 3.5c.251 0 .455.204.455.455v15.908a.455.455 0 0 1-.455.455h-4.848v2.727a.455.455 0 0 1-.658.407l-6.267-3.134h-7.317a.455.455 0 0 1-.455-.455V3.955c0-.251.203-.455.454-.455zM21.41 19.409h6.97l.104.012q.052.013.1.036l5.705 2.852v-2.446c0-.25.204-.454.455-.454h4.848v-15H21.409z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M35.349 9.41a.455.455 0 0 1 0 .908h-9.697a.455.455 0 1 1 0-.909zM35.349 13.652a.455.455 0 0 1 0 .909h-9.697a.455.455 0 1 1 0-.91z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m50.5 6 .99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-lg-feedback_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 0h30v30H15z"
  })))));
};
export { SvgAiLgFeedback as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-lg-feedback-02be2fc26b49b8395d052b0a6a7906f1.svg";